export const FOLDER_DRAG_EVENT_TYPE = 'FOLDER_DRAG';
